import { createAction } from 'redux-actions';
import initialState from './initialState';
import formatActionTypeNames from '../helpers/formatActionTypeNames';

import { actions as appActions } from '../reducers/app.reducer';

export const actions = formatActionTypeNames(
	{
		getContacts: 'GET_CONTACTS',
		getContactsComplete: 'GET_CONTACTS_COMPLETE',
	},
	'CONTACTS'
);

export const pagesActions = {
	getContacts: createAction(actions.getContacts),
	getContactsComplete: createAction(actions.getContactsComplete),
};

export default (state = initialState.pages, action) => {
	const { payload } = action;

	switch (action.type) {

		case appActions.booted:
			return {
				...state,
				...payload.contacts,
			};

		default:
			return state;
	}
};
